/* Shared guide interactions. No account or shopping data is stored here. */
(function () {
  if (window.loowSeasonGuide) return;
  window.loowSeasonGuide = true;
  var key = 'loow_gender';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var stored;
  try { stored = window.localStorage.getItem(key); } catch (error) { stored = null; }
  var requested = new URLSearchParams(window.location.search).get('gender');
  var gender = requested === 'women' || requested === 'men' ? requested : stored === 'women' ? 'women' : 'men';

  var revision = 0;

  function items(scope, value) {
    return Array.from(scope.querySelectorAll('.loow-season__step-products[data-gender="' + value + '"], .loow-season__step[data-gender="' + value + '"]')).filter(function (item) {
      // A gender-specific step already moves its product images with it.
      return item.getClientRects().length && !item.parentElement.closest('.loow-season__step[data-gender="' + value + '"]');
    });
  }

  function apply(animate) {
    var current = ++revision;
    var selected = gender;
    document.querySelectorAll('[data-gender-scope]').forEach(function (scope) {
      scope.querySelectorAll('.loow-season__step-products, .loow-season__step').forEach(function (item) {
        if (item.getAnimations) item.getAnimations().forEach(function (animation) { animation.cancel(); });
      });
      scope.querySelectorAll('.loow-season__switch-btn').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.gender === selected));
      });
      var previous = scope.dataset.activeGender;
      if (!animate || reduced.matches || !scope.animate || !previous || previous === selected) {
        scope.dataset.activeGender = selected;
        return;
      }
      var direction = selected === 'women' ? 1 : -1;
      var leaving = items(scope, previous).map(function (item) {
        return item.animate([
          { opacity: 1, transform: 'none' },
          { opacity: 0, transform: 'translateX(' + (-40 * direction) + 'px)' }
        ], { duration: 260, easing: 'cubic-bezier(.4, 0, 1, 1)', fill: 'forwards' });
      });
      Promise.all(leaving.map(function (animation) {
        return animation.finished.catch(function () { /* A newer choice cancels this transition. */ });
      })).then(function () {
        if (current !== revision) return;
        scope.dataset.activeGender = selected;
        leaving.forEach(function (animation) { animation.cancel(); });
        items(scope, selected).forEach(function (item, index) {
          var entering = item.animate([
            { opacity: 0, transform: 'translateX(' + (48 * direction) + 'px)' },
            { opacity: 1, transform: 'none' }
          ], { duration: 550, delay: index * 40, easing: 'cubic-bezier(.16, 1, .3, 1)', fill: 'backwards' });
          entering.finished.catch(function () { /* Rapid toggles can interrupt entry. */ });
        });
      });
    });
    document.querySelectorAll('[data-season-link]').forEach(function (link) {
      link.href = gender === 'women' ? link.dataset.womenUrl : link.dataset.menUrl;
    });
    // Impulse wraps all RTE tables. The comparison owns its scroll container.
    document.querySelectorAll('.loow-cmp > .table-wrapper').forEach(function (wrapper) {
      wrapper.replaceWith.apply(wrapper, Array.from(wrapper.childNodes));
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.loow-season__switch-btn');
    if (!button || gender === button.dataset.gender) return;
    gender = button.dataset.gender;
    try { window.localStorage.setItem(key, gender); } catch (error) { /* Choice still works for this page. */ }
    apply(true);
  });
  document.addEventListener('shopify:section:load', function () { apply(false); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) apply(false); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(false); });
  else apply(false);
})();
